module.exports = __webpack_public_path__ + "static/media/globe.31cee8ad.svg";